import type { PickUnion } from '../../../types/PickUnion'
import type { FilterGroupObject } from './FilterDefinition'
import type { FilterIds } from '../../../types/FilterIds'

export type ServiceFilterServiceProviderTypes = PickUnion<
  FilterIds,
  | 'service-provider:voluntary-community-and-social-enterprise'
  | 'service-provider:nhs'
  | 'service-provider:private-provider'
  | 'service-provider:local-authority'
  | 'service-provider:private-provider-free'
  | 'service-provider:private-provider-paid'
>

/** The service provider types for a service */
export const serviceFilterServiceProviderTypes = [
  'service-provider:voluntary-community-and-social-enterprise',
  'service-provider:nhs',
  'service-provider:private-provider',
  'service-provider:local-authority',
  'service-provider:private-provider-free',
  'service-provider:private-provider-paid'
] as const

type ServiceProviderTypeObj = FilterGroupObject<ServiceFilterServiceProviderTypes>

export const generateServiceFilterProviderTypesObjects = (): ServiceProviderTypeObj => ({
  'service-provider:voluntary-community-and-social-enterprise': {
    selected: false,
    label: 'Charities and community groups',
    key: 'service-provider:voluntary-community-and-social-enterprise',
    filterId: 'service-provider:voluntary-community-and-social-enterprise',
    serviceFilterKey: 'isVCSEProvider'
  },
  'service-provider:nhs': {
    selected: false,
    label: 'NHS service',
    key: 'service-provider:nhs',
    filterId: 'service-provider:nhs',
    serviceFilterKey: 'isNHSProvider'
  },
  'service-provider:private-provider': {
    selected: false,
    label: 'Private sector',
    key: 'service-provider:private-provider',
    filterId: 'service-provider:private-provider',
    serviceFilterKey: 'isPrivateProvider',
    toolTipContent:
      'Includes businesses and organisations that offer paid mental health services. Private therapists are also part of this sector when they charge for their services'
  },
  'service-provider:local-authority': {
    selected: false,
    label: 'Local authority',
    key: 'service-provider:local-authority',
    filterId: 'service-provider:local-authority',
    serviceFilterKey: 'isLocalAuthorityProvider'
  },
  'service-provider:private-provider-free': {
    selected: false,
    label: 'Private sector (free)',
    key: 'service-provider:private-provider-free',
    filterId: 'service-provider:private-provider-free',
    frontEndHidden: true,
    serviceFilterKey: 'isPrivateSectorFreeProvider'
  },
  'service-provider:private-provider-paid': {
    selected: false,
    label: 'Private sector (paid)',
    key: 'service-provider:private-provider-paid',
    filterId: 'service-provider:private-provider-paid',
    frontEndHidden: true,
    serviceFilterKey: 'isPrivateSectorPaidProvider'
  }
})
